import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetUserEventsList } from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import MainPagination from "../../Common/MainPagination";
import Event from "./Event";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const UserEventList = () => {
  const location = useLocation();
  const [loading, sendRequest, error] = useHttpHook();
  const [events, setEvents] = useState();

  const getEvents = useCallback(
    async (page = 1) => {
      try {
        let listType = "";
        if (location.pathname === "/MyEvents/cancelled") {
          listType = "cancelled";
        } else if (location.pathname === "/MyEvents/visited") {
          listType = "visited";
        }

        const query = listType
          ? `${GetUserEventsList}?listType=${listType}&page=${page}`
          : `${GetUserEventsList}?page=${page}`;

        const response = await sendRequest(query, { method: "get" });

        if (response.status === 1) {
          if (page === 1) {
            setEvents(response);
          } else {
            setEvents((prevState) =>
              createObjectForPaginatedResult(response, prevState, "paginate")
            );
          }
        }
      } catch (fetchError) {
        console.log({ fetchError });
      }
    },
    [location.pathname, sendRequest]
  );

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  useEffect(() => {
    if (error && toast.isActive(error) === false) {
      showErrorToast(error);
      if (error === "You are unAuthrised") {
        window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
      }
    }
  }, [error]);

  const items = events?.data?.itemsList || [];

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      {events ? (
        <MainPagination
          getEventsMethod={getEvents}
          MainData={events}
          PaginationType="paginate"
        >
          <div className="event-my-events-grid" role="list" aria-label="My events list">
            {items.length > 0 ? (
              items.map(
                (
                  {
                    _id,
                    title,
                    eventTiming,
                    category,
                    location: eventLocation,
                    mainimage,
                    wishlist,
                  },
                  index
                ) => (
                  <Event
                    key={_id || index}
                    layout="my-events"
                    title={title}
                    eventTiming={eventTiming}
                    category={category}
                    location={eventLocation}
                    Id={_id}
                    mainimage={mainimage}
                    wishlist={wishlist}
                  />
                )
              )
            ) : (
              <div className="event-my-events-empty">
                <i className="bi bi-calendar2-event" aria-hidden="true"></i>
                <p>No events found.</p>
              </div>
            )}
          </div>
        </MainPagination>
      ) : (
        <div className="event-my-events-empty">
          <i className="bi bi-calendar2-event" aria-hidden="true"></i>
          <p>No events found.</p>
        </div>
      )}
    </MainComponentWrapper>
  );
};

export default UserEventList;
